export enum TradePartnerNameAndLogoClamping {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}
